import React, { useContext, useEffect, useRef, useState } from 'react'
import {
  FormGroup,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
} from 'reactstrap'
import DateTime from 'react-datetime';
import 'moment/locale/pt-br';
import settings from 'settings';
import rest from 'lib/rest';
import rotas from 'services/rotas';
import ReactSelect from 'components/Form/Select/Select';
import Swal from 'sweetalert2';
import Iframe from 'react-iframe';
import AsyncSelect from 'react-select/async';
import useForm from 'lib/useForm';
import Loading from 'lib/loading'
import {homepage} from '../../../package.json';
import {validarData} from '../../lib/validaData'
import moment from 'moment';

// import ReactSelectCreatable from 'components/Form/Select/SelectCreatable';
// import ReactSelectCreatable from 'components/Form/Select/SelectCreatable2';
import CreatableSelect from 'react-select/creatable';


const inicialForm = {
  dataI: "",
  dataF: "",
  filial_id: "",
  lojaSelect: "",
  plano_conta_id: '',
  planoContaSelect: "",
  vendedor_id: '',
  vendedorAtivo:'',
  selectVendedorAtivo: '',
  vendedorSelect: "",
  convenio_id: '',
  convenioSelect: "",
  cliente_id: '',
  clienteSelect: '',
  fornecedor_id: '',
  fornecedorSelect: "",
  categoria_id:'',
  subcategoria_id:'',
  categoriaSelect: "",
  subcategoriaSelect: "",
  produto_id:'',
  produtoSelect: "",
  clienteAtivo: "",
  selectClienteAtivo: "",
  selectComissao: "",
  comissao: "S",
  clientesDiasAtrasoI: '30',
  clientesDiasAtrasoF: '60',
  cfop: '',
  rede: sessionStorage.getItem('rede'),
  usuario: sessionStorage.getItem('usuario')
}

const inicialFiltros = {
  dataI:false,
  dataF:false,
  selectLoja: false,
  selectCategoria: false,
  selectSubcategoria: false,
  selectCliente: false,
  selectConvenio: false,
  selectFornecedor: false,
  selectVendedor: false,
  selectVendedorAtivo: false,
  selectPlanoContas: false,
  selectProduto: false,
  selectClienteAtivo: false,
  clientesDiasAtraso: false,
  selectCfop: false,
  selectComissao: false,
}

const RelatorioFiltro = (props) => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [lojas, setLojas] = useState([]);
  const [listaVendedores, setListaVendedores] = useState([]);
  const [planoContas, setPlanoContas] = useState([]);
  const [modal, setModal] = useState(false);
  const [pathPDF, setPathPDF] = useState('');
  const [listaConvenios, setListaConvenios] = useState([]);
  const [listaFornecedor, setListaFornecedor] = useState([]);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaSubcategoria, setListasubcategoria] = useState([]);
  const [loading, setLoading] = useState(false)
  const [disabeldFiltros, setdisabeldFiltros] = useState(inicialFiltros)

  // Evita setState em componente desmontado (memory leak warning)
  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => { isMountedRef.current = false; };
  }, []);

  useEffect(() => {
    listarLojas();
    listarVendedores();
    listarConvenios()
    listaPlanoContas(1)
    listarCategorias()
    listarSubcategorias();
    listarFornecedores();
  }, [])

  useEffect(()=>{
    listaFiltros();
  },[props.paramRelatorio.filtros])

  const listaFiltros = () =>{
    if(Array.isArray(props.paramRelatorio.filtros)){

      const df = disabeldFiltros;

      df.dataI = true;
      df.dataF = true;
      df.selectLoja = true;
      df.selectCategoria = true;
      df.selectSubcategoria = true;
      df.selectCliente = true;
      df.selectConvenio = true;
      df.selectFornecedor = true;
      df.selectVendedor = true;
      df.selectVendedorAtivo = true;
      df.selectPlanoContas = true;
      df.selectProduto = true;
      df.selectClienteAtivo = true;
      df.clientesDiasAtraso = true;
      df.selectCfop = true;
      df.clientesDiasAtraso = true;
      df.selectComissao = true;

      props.paramRelatorio.filtros.map(filtro=>{
        
        if(filtro === 'dataI'){
          df.dataI = false;
        }

        if(filtro === 'dataF'){
          df.dataF = false;
        }

        if(filtro === 'filial'){
          df.selectLoja = false;
        }

        if(filtro === 'categoria'){
          df.selectCategoria = false
        }

        if(filtro === 'subcategoria'){
          df.selectSubcategoria = false
        }

        if(filtro === 'cliente'){
          df.selectCliente = false
        }

        if(filtro === 'convenio'){
          df.selectConvenio = false
        }

        if(filtro === 'fornecedor'){
          df.selectFornecedor = false
        }

        if(filtro === 'vendedor'){
          df.selectVendedor = false
        }

        if(filtro === 'vendedorAtivo'){
          df.selectVendedorAtivo = false
        }

        if(filtro === 'plano_contas'){
          df.selectPlanoContas = false
        }

        if(filtro === 'produto'){
          df.selectProduto = false
        }

        if(filtro === 'clienteAtivo'){
          df.selectClienteAtivo = false
        }

        if(filtro === 'diasAtraso'){
          df.clientesDiasAtraso = false
        }

        if(filtro === 'cfop'){
          df.selectCfop = false
        }
        if(filtro === 'comissao'){
          df.selectComissao = false
        }

      })
      setdisabeldFiltros(df);
    }
  }

  const listarLojas = () => {
    const url     = settings.url + rotas.filtroLojasRelatorio,
          retorno = rest.get(url);

    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = []
        ret.lista.map(lst => {
          lista.push({ id: lst.filial_id, title: lst.fantasia });
          if (lst.is_central === "S") {
            listarFornecedores(lst.filial_id)
          }
        });
        setLojas(lista);
      }
    })
  }

  const listaPlanoContas = (id) => {
    if (id > 0) {
      const url     = settings.url + rotas.planoContas,
            retorno = rest.get(url);
  
      retorno.then(ret => {
        if (!isMountedRef.current) return;
        if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
          let lista = []
          ret.lista.map(lst => {
            lista.push({ id: lst.plano_contas_id, title: lst.plano_contas });
          });
          setPlanoContas(lista);
        }else{
          setPlanoContas([])
        }
      })
    }
  }

  const listarVendedores = () => {
    const url     = settings.url + rotas.vendedor,
          retorno = rest.get(url);

    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.vendedor_id, title: lst.vendedor });
        });
        setListaVendedores(lista);
      }
    })
  }

  const listarConvenios = () => {
    const url     = settings.url + rotas.convenios,
          retorno = rest.get(url);

    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.convenio_id, title: lst.convenio });
        });
        setListaConvenios(lista);
      }
    })
  }

  const listarFornecedores = (filial_id) => {
    const url     = settings.url + rotas.fornecedorProduto;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setListaFornecedor(lista);
      }
    })
  }

  const listarCategorias = (filial_id) => {
    const url     = settings.url + rotas.categoriaProduto;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setListaCategoria(lista);
      }
    })
  }

  const listarSubcategorias = () => {
    const url     = settings.url + rotas.subcategoriaProduto;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (!isMountedRef.current) return;
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.subcategoria_id, title: lst.subcategoria });
        });
        setListasubcategoria(lista);
      }
    })
  }

  const formatDate = (data) => {
    let array = data.split("/")
    let date  = array[2] + "-" + array[1] + "-" + array[0]
    
    return new Date(date).toISOString().slice(0, 10)
  }

  //componente datatime, campo vazio
  // const focousOutI = (value) => {
  //   if(!moment(value).isValid()) {
  //    form.dataI = '';
  //   }
  // }
  // const focousOutF = (value) => {
  //   if(!moment(value).isValid()) {
  //    form.dataF = '';
  //   }
  // }

  /* ── monta o objeto de filtros a partir do form ── */
  const montarFiltros = () => {
    let filtros = {
      dataI:                form.dataI,
      dataF:                form.dataF,
      filial_id:            form.filial_id ? form.filial_id : "",
      plano_conta_id:       form.planoContas_id,
      vendedor_id:          form.vendedor_id,
      selectVendedorAtivo:  form.selectVendedorAtivo,
      vendedorAtivo:        form.vendedorAtivo,
      convenio_id:          form.convenio_id,
      cliente_id:           form.cliente_id,
      fornecedor_id:        form.fornecedor_id,
      categoria_id:         form.categoria_id,
      subcategoria_id:      form.subcategoria_id,
      produto_id:           form.produto_id ? form.produto_id : "",
      selectClienteAtivo:   form.selectClienteAtivo,
      clienteAtivo:         form.clienteAtivo,
      clientesDiasAtrasoI:  form.clientesDiasAtrasoI,
      clientesDiasAtrasoF:  form.clientesDiasAtrasoF,
      cfop:                 form.cfop,
      comissao:             form.comissao,
      rede:                 sessionStorage.getItem('rede'),
      usuario:              sessionStorage.getItem('usuario'),
      clienteSelect:        form.clienteSelect,
      lojaSelect:           (form.lojaSelect          && form.lojaSelect.length == 0)         ? "" : form.lojaSelect,
      planoContaSelect:     (form.planoContaSelect    && form.planoContaSelect.length == 0)   ? "" : form.planoContaSelect,
      vendedorSelect:       (form.vendedorSelect      && form.vendedorSelect.length == 0)     ? "" : form.vendedorSelect,
      convenioSelect:       (form.convenioSelect      && form.convenioSelect.length == 0)     ? "" : form.convenioSelect,
      fornecedorSelect:     (form.fornecedorSelect    && form.fornecedorSelect.length == 0)   ? "" : form.fornecedorSelect,
      categoriaSelect:      (form.categoriaSelect     && form.categoriaSelect.length == 0)    ? "" : form.categoriaSelect,
      subcategoriaSelect:   (form.subcategoriaSelect  && form.subcategoriaSelect.length == 0) ? "" : form.subcategoriaSelect,
      produtoSelect:        (form.produtoSelect       && form.produtoSelect.length == 0)      ? "" : form.produtoSelect,
    }

    // se nenhuma loja selecionada, envia todas (padrão dos relatórios)
    if ((filtros.lojaSelect === "") || (filtros.lojaSelect === null)) {
      filtros.lojaSelect = lojas;
    }

    filtros.rede      = sessionStorage.getItem('rede')
    filtros.usuario   = sessionStorage.getItem('usuario')
    filtros.filial_id = filtros.filial_id ? filtros.filial_id : ""

    return filtros;
  }

  /* ── valida datas e formata; retorna false se inválidas ── */
  const validarFiltros = (filtros) => {
    if (filtros.dataI !== '') {
      if (!validarData(filtros.dataI)) {
        Swal.fire('Atenção', 'Por favor digite uma data válida!', 'warning');
        return false;
      }
    }
    if (filtros.dataF !== '') {
      if (!validarData(filtros.dataF)) {
        setForm(inicialForm);
        setLoading(false);
        Swal.fire('Atenção', 'Por favor digite uma data válida!', 'warning');
        return false;
      }
    }
    filtros.dataI = filtros.dataI ? formatDate(filtros.dataI) : "";
    filtros.dataF = filtros.dataF ? formatDate(filtros.dataF) : "";
    return true;
  }

  /* ── monta o caminho base da URL a partir do path do relatório ── */
  const montarCaminho = () => {
    const caminho = props.paramRelatorio.path.split('/');
    let caminhoPDF = '';
    for (let x = 0; x < caminho.length - 1; x++) {
      caminhoPDF = caminhoPDF === '' ? caminho[x] : caminhoPDF + '/' + caminho[x];
    }
    return caminhoPDF;
  }

  const gerarRelatorio = () => {
    if ((props.paramRelatorio.nome_relatorio === '') || (props.paramRelatorio.nome_relatorio === undefined)) {
      Swal.fire('Atenção', 'Por favor selecione um relatório!', 'warning');
      return;
    }

    const filtros = montarFiltros();
    if (!validarFiltros(filtros)) return;

    Swal.fire({
      title:             'Gerando PDF...',
      text:              'Por favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey:    false,
      showConfirmButton: false,
      didOpen:           () => Swal.showLoading(),
    });

    const url     = props.paramRelatorio.path,
          retorno = rest.post(url, { filtros });

    retorno.then(ret => {
      Swal.close();
      if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
        setPathPDF(homepage + '/' + montarCaminho() + ret.path);
        setModal(true);
      } else {
        Swal.fire('Erro', 'Erro na geração do relatório', 'error');
      }
    }).catch(() => {
      Swal.fire('Erro', 'Erro na geração do relatório. Tente novamente.', 'error');
    });
  }

  /* ── gera relatório em Excel (só aparece quando excel === 'S' no banco) ── */
  const gerarExcel = () => {
    if ((props.paramRelatorio.nome_relatorio === '') || (props.paramRelatorio.nome_relatorio === undefined)) {
      Swal.fire('Atenção', 'Por favor selecione um relatório!', 'warning');
      return;
    }

    const filtros = montarFiltros();
    if (!validarFiltros(filtros)) return;

    Swal.fire({
      title:             'Gerando Excel...',
      text:              'Por favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey:    false,
      showConfirmButton: false,
      didOpen:           () => Swal.showLoading(),
    });

    const url     = props.paramRelatorio.path,
          retorno = rest.post(url, { filtros, formato: 'excel' });

    retorno.then(ret => {
      Swal.close();
      if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
        window.open(homepage + '/' + montarCaminho() + ret.path);
      } else {
        Swal.fire('Erro', 'Erro na geração do Excel', 'error');
      }
    }).catch(() => {
      Swal.fire('Erro', 'Erro na geração do Excel. Tente novamente.', 'error');
    });
  }

  const pesquisaCliente = (cliente) => {

    if (cliente.length >= 3) {

      const url     = settings.url + rotas.filtroClienteRelatorio,
            retorno = rest.get(url + '?cliente=' + cliente);
      
      let oClientes = [];
      return retorno.then(ret => {
        ret.lista.map(cliente =>
          oClientes.push({ id: cliente.cliente_id, value: cliente.cliente_id, label: cliente.cliente, cliente_id: cliente.cliente_id })
        )
        return (oClientes);
      })
    }
  }

  const pesquisaProduto = (produto) => {

    if (produto.length >= 3) {
      
      const url     = settings.url + rotas.filtroProdutoRelatorio,
            retorno = rest.get(url + '?produto=' + produto);

      let rProdutos = [];
      return retorno.then(ret => {
        ret.lista.map(produto =>{
          rProdutos.push({ value: produto.produto_id, label: produto.produto, cod_barras: produto.cod_barras || '' })
      })
      return (rProdutos);
    })
    }
  }

  const listaCfop = [
    { value: "5101", label: "5101", },
    { value: "5102", label: "5102", },
    { value: "5405", label: "5405", },
    { value: "5910", label: "5910", },
    { value: "5911", label: "5911", },
    { value: "5912", label: "5912", },
    { value: "5913", label: "5913", },
    { value: "5914", label: "5914", },
    { value: "5915", label: "5915", },
    { value: "5916", label: "5916", },
    { value: "5917", label: "5917", },
    { value: "5918", label: "5918", },
    { value: "5919", label: "5919", },
    { value: "5920", label: "5920", },
    { value: "5921", label: "5921", },
    { value: "5922", label: "5922", },
    { value: "5923", label: "5923", },
    { value: "5924", label: "5924", },
    { value: "5925", label: "5925", },
    { value: "5926", label: "5926", },
    { value: "5927", label: "5927", },
    { value: "5928", label: "5928", },
    { value: "5929", label: "5929", },
    { value: "5930", label: "5930", },
    { value: "5931", label: "5931", },
    { value: "5932", label: "5932", },
    { value: "5933", label: "5933", },
    { value: "5934", label: "5934", },
    { value: "5935", label: "5935", },
    { value: "5949", label: "5949", },
  ];

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  } else {
    return (
      <div>
        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modal}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
                </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModal(false)}}>Fechar</Button>
            </Col>
          </Row>
        </Modal>
        <Row className="inputXL">
          <Col>
            <FormGroup>
              <DateTime
              id            = "dataInicial"
              name          = "dataInicial"
              timeFormat    = {false}
              closeOnSelect = {true}
              dateFormat    = "YYYY-MM-DD"
              value         = {form.dataI}
              onChange      = {onChangeDate('dataI')}          
              inputProps    = {{
                                className: disabeldFiltros.dataI === true ? "form-control disabledCampo" : "form-control",
                                placeholder: "Data Inicial",
                                disabled:disabeldFiltros.dataI
                              }}
              // onBlur        = {focousOutI}
              />
            </FormGroup>
          </Col>
  
          <Col>
            <FormGroup>
              <DateTime
                id            = "dataIFinal"
                name          = "dataIFinal"
                timeFormat    = {false}
                closeOnSelect = {true}
                dateFormat    = "YYYY-MM-DD"
                value         = {form.dataF}
                onChange      = {onChangeDate('dataF')}
                inputProps    = {{
                                  className: disabeldFiltros.dataI === true ? "form-control disabledCampo" : "form-control",
                                  placeholder: "Data Final",
                                  disabled:disabeldFiltros.dataF
                                }}
                // onBlur        = {focousOutF}

              />
            </FormGroup>
          </Col>
        </Row>
  
        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectLoja}
        >
          <ReactSelect
            isMulti
            id              = "selectLoja"
            name            = "selectLoja"
            className       = {disabeldFiltros.selectLoja === true ? "react-select selectXL mb-2 disabledCampo" : "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione a Loja"
            options         = {lojas}
            onChange        = {onChangeSelect('lojaSelect')}
            onClick         = {form.lojaSelect ? form.filial_id = form.lojaSelect.id : ''}
            defaultValue    = {form.loja_id}
            isDisabled      = {disabeldFiltros.selectLoja}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectCategoria}
        >
          <ReactSelect
            isMulti
            id              = "selectCategoria"
            name            = "selectCategoria"
            className       = "react-select selectXL mb-2"
            classNamePrefix = "react-select"
            placeholder     = "Selecione a Categoria"
            options         = {listaCategoria}
            onChange        = {onChangeSelect('categoriaSelect')}
            onClick         = {form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectCategoria}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectSubcategoria}
        >
          <ReactSelect
            isMulti
            id              = "selectSubcategoria"
            name            = "selectSubcategoria"
            className       = "react-select selectXL mb-2"
            classNamePrefix = "react-select"
            placeholder     = "Selecione a Subcategoria"
            options         = {listaSubcategoria}
            onChange        = {onChangeSelect('subcategoriaSelect')}
            onClick         = {form.subcategoriaSelect ? form.subcategoria_id = form.subcategoriaSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectSubcategoria}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectCliente}
        >
          <AsyncSelect
            cacheOptions 
            defaultOptions 
            id              = "selectCliente"
            name            = "selectCliente"
            className       = {disabeldFiltros.selectCliente === true ? "react-select selectXL mb-2 disabledCampo" : "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Cliente"
            loadOptions        = {pesquisaCliente}
            onChange           = {onChangeSelect('clienteSelect')}
            onClick            = {form.clienteSelect ? form.cliente_id = form.clienteSelect.id : ''}
            isDisabled         = {disabeldFiltros.selectCliente}
            noOptionsMessage   = {() => "Nenhum cliente encontrado"}
            loadingMessage     = {() => "Buscando..."}
            formatOptionLabel  = {(opt) => (
              <div>
                <div style={{ fontSize: '13px' }}>{opt.label}</div>
                {opt.cliente_id && <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}><i className="ti ti-id-badge" style={{ fontSize: '12px', marginRight: '4px' }} aria-hidden="true" />Cód. {opt.cliente_id}</div>}
              </div>
            )}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectConvenio}
        >
          <ReactSelect
            isMulti
            id              = "selectConvenio"
            name            = "selectConvenio"
            className       = {disabeldFiltros.selectConvenio === true ? "react-select selectXL mb-2 disabledCampo" :"react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Convênio"
            options         = {listaConvenios}
            onChange        = {onChangeSelect('convenioSelect')}
            onClick         = {form.convenioSelect ? form.convenio_id = form.convenioSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectConvenio}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectFornecedor}
        >
          <ReactSelect
            isMulti
            id              = 'slecFornecedor'
            name            = "selectFornecedor"
            key             = 'slecFornecedores'
            className       = {disabeldFiltros.selectFornecedor === true ? "react-select selectXL  mb-2 disabledCampo" : "react-select selectXL  mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Fornecedor"
            options         = {listaFornecedor}
            onChange        = {onChangeSelect('fornecedorSelect')}
            onClick         = {form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectFornecedor}
          />
        </Col>
  
        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectVendedor}
        >                                
          <ReactSelect
            isMulti
            id              = "selectVendedor"
            name            = "selectVendedor"
            className       = {disabeldFiltros.selectVendedor === true ? "react-select selectXL  mb-2 disabledCampo" : "react-select selectXL  mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Vendedor"
            options         = {listaVendedores}
            onChange        = {onChangeSelect('vendedorSelect')}
            onClick         = {form.vendedorSelect ? form.vendedor_id = form.vendedorSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectVendedor}
          />
        </Col>
        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectVendedorAtivo}
        >
          <ReactSelect
            id              = "selectVendedorAtivo"
            name            = "selectVendedorAtivo"
            className       = {disabeldFiltros.selectVendedorAtivo === true ? "react-select selectXL mb-2 disabledCampo": "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione vendedor ativo ou bloqueado"
            options         = {[{ id: '', title: 'TODOS OS VENDEDORES'},{ id: 'S', title: 'VENDEDORES ATIVOS'},{ id: 'N', title: 'VENDEDORES BLOQUEADOS'}]}
            onChange        = {onChangeSelect('selectVendedorAtivo')}
            onClick         = {form.selectVendedorAtivo ? form.vendedorAtivo = form.selectVendedorAtivo.id : ''}
            isDisabled      = {disabeldFiltros.selectVendedorAtivo}
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectPlanoContas}
        >
          <ReactSelect
            isMulti
            id              = "scPlanoConta"
            name            = "selectPlanoContas"
            className       = {disabeldFiltros.selectPlanoContas === true ? "react-select selectXL mb-2 disabledCampo": "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Plano de Contas"
            options         = {planoContas}
            onChange        = {onChangeSelect('planoContaSelect')}
            onClick         = {form.planoContaSelect ? form.plano_conta_id = form.planoContaSelect.id : ''}
            isDisabled      = {disabeldFiltros.selectPlanoContas}
          />
        </Col>
      
        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectProduto}
        >
          <AsyncSelect
            isMulti
            cacheOptions 
            defaultOptions 
            id              = "selectProdutos"
            name            = "selectProdutos"
            className       = {disabeldFiltros.selectProduto === true ? "react-select selectXL mb-2 disabledCampo" : "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o Produto"
            loadOptions        = {pesquisaProduto}
            onChange           = {onChangeSelect('produtoSelect')}
            onClick            = {form.produtoSelect ? form.produto_id = form.produtoSelect.id : ''}
            isDisabled         = {disabeldFiltros.selectProduto}
            noOptionsMessage   = {() => "Nenhum produto encontrado"}
            loadingMessage     = {() => "Buscando..."}
            formatOptionLabel  = {(opt) => (
              <div>
                <div style={{ fontSize: '13px' }}>{opt.label}</div>
                {opt.cod_barras && <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}><i className="ti ti-barcode" style={{ fontSize: '12px', marginRight: '4px' }} aria-hidden="true" />{opt.cod_barras}</div>}
              </div>
            )}
          
          />
        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectClienteAtivo}
        >
          <ReactSelect
            id              = "selectClienteAtivo"
            name            = "selectClienteAtivo"
            className       = {disabeldFiltros.selectClienteAtivo === true ? "react-select selectXL mb-2 disabledCampo": "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione cliente ativo ou bloqueado"
            options         = {[{ id: '', title: 'TODOS OS CLIENTES'},{ id: 'N', title: 'CLIENTES ATIVOS'},{ id: 'S', title: 'CLIENTES BLOQUEADOS'}]}
            onChange        = {onChangeSelect('selectClienteAtivo')}
            onClick         = {form.selectClienteAtivo ? form.clienteAtivo = form.selectClienteAtivo.id : ''}
            isDisabled      = {disabeldFiltros.selectClienteAtivo}
          />
        </Col>

        <Row className="inputXL" hidden = {disabeldFiltros.clientesDiasAtraso}>
          <Col>
            <FormGroup>
              <Label for = "clientesDiasAtrasoI">{'Clientes entre '+form.clientesDiasAtrasoI } </Label>
              <Input
                id          = "clientesDiasAtrasoI"
                name        = "clientesDiasAtrasoI"
                type        = "number"
                placeholder = "Entre dias"
                onChange    = {onChange('clientesDiasAtrasoI')}
                defaultValue  = '30'
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for = "clientesDiasAtrasoF">{'e '+form.clientesDiasAtrasoF+' dias em atraso'}</Label>
              <Input
                id          = "clientesDiasAtrasoF"
                name        = "clientesDiasAtrasoF"
                type        = "number"
                placeholder = "Entre dias"
                onChange    = {onChange('clientesDiasAtrasoF')}
                defaultValue  = '60'
              />
            </FormGroup>
          </Col>
        </Row>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectCfop}
        >
          {/* <ReactSelectCreatable
            isMulti
            id              = "selectCfop"
            name            = "selectCfop"
            className       = {disabeldFiltros.selectCfop === true ? "react-select selectXL mb-2 disabledCampo" : "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Selecione o CFOP"
            options         = {listaCfop}
            onChange        = {onChangeSelect('cfop')}
            onClick         = {form.cfop ? form.cfop = form.cfop.id : ''}
            isDisabled      = {disabeldFiltros.selectCfop}
          /> */}

          <CreatableSelect
            isMulti
            id                = "selectCfop"
            name              = "selectCfop"
            className         = {disabeldFiltros.selectCfop === true ? "react-select selectXL mb-2 disabledCampo" : "react-select selectXL mb-2"}
            classNamePrefix   = "react-select"
            placeholder       = "Selecione ou digite o CFOP"
            noOptionsMessage  ={() => "Nenhuma opção encontrada"}
            formatCreateLabel ={(inputValue) => `Incluir opção digitada "${inputValue}"`}
            options           = {listaCfop}
            onChange          = {onChangeSelect('cfop')}
            isDisabled        = {disabeldFiltros.selectCfop}
          />

        </Col>

        <Col
          className = {'p-0 m-0'} 
          hidden    = {disabeldFiltros.selectComissao}
        >
          <ReactSelect
            id              = "selectComissao"
            name            = "selectComissao"
            className       = {disabeldFiltros.selectComissao === true ? "react-select selectXL mb-2 disabledCampo": "react-select selectXL mb-2"}
            classNamePrefix = "react-select"
            placeholder     = "Mostrar vendas com comissão"
            options         = {[{ id: 'S', title: 'Mostrar apenas vendas com comissão'},{ id: 'N', title: 'Mostrar todas as vendas'}]}
            onChange        = {onChangeSelect('selectComissao')}
            onClick         = {form.selectComissao ? form.comissao = form.selectComissao.id : 'S'}
            isDisabled      = {disabeldFiltros.selectComissao}
          />
        </Col>

        <div className="d-flex align-items-stretch" style={{ gap: '6px' }}>
          <Button
            className = "flex-grow-1"
            color     = "success"
            size      = "lg"
            onClick   = {gerarRelatorio}
          >
            <i className="fa fa-file-pdf-o mr-2" />Gerar PDF
          </Button>

          {props.paramRelatorio.excel === 'S' && (
            <Button
              size    = "lg"
              onClick = {gerarExcel}
              title   = "Exportar para Excel"
              style   = {{
                border:          '1px solid #1d6f42',
                color:           '#1d6f42',
                backgroundColor: 'transparent',
                whiteSpace:      'nowrap',
                padding:         '0 14px',
              }}
            >
              <i className="fa fa-file-excel-o mr-1" />
              <span style={{ fontSize: '13px' }}>Gerar Excel</span>
            </Button>
          )}
        </div>
  
      </div>
    )
  }

}

export default RelatorioFiltro;